export default __webpack_public_path__ + "static/mobile-2330e82a58af43a56cb3c3296526dd46.svg";